/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import { AdVehicleStreamPassengerCardStopInfoFragmentDoc } from '../../../../ad-vehicle-stream/src/lib/AdVehicleStream/PassengerCard/PassengerCard.hook'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
import {
  AdPassengerRowCustomerFragmentDoc,
  AdPassengerRowSeatInfoFragmentDoc,
} from '../components/AdPassengerRow/AdPassengerRow.hook'
export type GetPassengersWaypointFragment = {
  __typename?: 'FccWaypoint'
  stop: {
    __typename?: 'Stop'
    id: string
    names: Partial<Record<'de' | 'en', string>>
    serviceArea: { __typename?: 'ServiceArea'; id: string }
  } | null
  actions: Array<
    | {
        __typename: 'FccWaypointDeliveryAction'
        id: string
        estimatedAt: string
        pickedUpAt: string | null
        trip: { __typename?: 'Trip'; id: string } | null
        customer: {
          __typename?: 'Customer'
          firstName: string | null
          lastName: string | null
          extendedWalkingTime: boolean
          visualImpairment: boolean | null
        } | null
        seats: {
          __typename?: 'FccWaypointSeatInfo'
          seats: number
          wheelchairs: number
          childSeats: number
          boosterSeats: number
        }
      }
    | { __typename?: 'FccWaypointHubReturnAction' }
    | {
        __typename: 'FccWaypointPickupAction'
        id: string
        estimatedAt: string
        pickedUpAt: string | null
        adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
        notShownUpAt: string | null
        tripIsCancelled: boolean | null
        trip: { __typename?: 'Trip'; id: string } | null
        customer: {
          __typename?: 'Customer'
          firstName: string | null
          lastName: string | null
          extendedWalkingTime: boolean
          visualImpairment: boolean | null
        } | null
        seats: {
          __typename?: 'FccWaypointSeatInfo'
          seats: number
          wheelchairs: number
          childSeats: number
          boosterSeats: number
        }
      }
    | { __typename?: 'FccWaypointReallocationAction' }
  >
}

export type GetPassengersPickupActionFragment = {
  __typename: 'FccWaypointPickupAction'
  id: string
  estimatedAt: string
  pickedUpAt: string | null
  adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
  notShownUpAt: string | null
  tripIsCancelled: boolean | null
  trip: { __typename?: 'Trip'; id: string } | null
  customer: {
    __typename?: 'Customer'
    firstName: string | null
    lastName: string | null
    extendedWalkingTime: boolean
    visualImpairment: boolean | null
  } | null
  seats: {
    __typename?: 'FccWaypointSeatInfo'
    seats: number
    wheelchairs: number
    childSeats: number
    boosterSeats: number
  }
}

export type GetPassengersDeliveryActionFragment = {
  __typename: 'FccWaypointDeliveryAction'
  id: string
  estimatedAt: string
  pickedUpAt: string | null
  trip: { __typename?: 'Trip'; id: string } | null
  customer: {
    __typename?: 'Customer'
    firstName: string | null
    lastName: string | null
    extendedWalkingTime: boolean
    visualImpairment: boolean | null
  } | null
  seats: {
    __typename?: 'FccWaypointSeatInfo'
    seats: number
    wheelchairs: number
    childSeats: number
    boosterSeats: number
  }
}

export const GetPassengersPickupActionFragmentDoc = gql`
    fragment GetPassengersPickupAction on FccWaypointPickupAction {
  __typename
  id
  estimatedAt
  pickedUpAt
  adPassengerAuthenticationState
  notShownUpAt
  tripIsCancelled
  trip {
    id
  }
  customer {
    ...AdPassengerRowCustomer
  }
  seats {
    seats
    ...AdPassengerRowSeatInfo
  }
}
    ${AdPassengerRowCustomerFragmentDoc}
${AdPassengerRowSeatInfoFragmentDoc}`
export const GetPassengersDeliveryActionFragmentDoc = gql`
    fragment GetPassengersDeliveryAction on FccWaypointDeliveryAction {
  __typename
  id
  estimatedAt
  pickedUpAt
  trip {
    id
  }
  customer {
    ...AdPassengerRowCustomer
  }
  seats {
    seats
    ...AdPassengerRowSeatInfo
  }
}
    ${AdPassengerRowCustomerFragmentDoc}
${AdPassengerRowSeatInfoFragmentDoc}`
export const GetPassengersWaypointFragmentDoc = gql`
    fragment GetPassengersWaypoint on FccWaypoint {
  stop {
    ...AdVehicleStreamPassengerCardStopInfo
  }
  actions {
    ... on FccWaypointPickupAction {
      ...GetPassengersPickupAction
    }
    ... on FccWaypointDeliveryAction {
      ...GetPassengersDeliveryAction
    }
  }
}
    ${AdVehicleStreamPassengerCardStopInfoFragmentDoc}
${GetPassengersPickupActionFragmentDoc}
${GetPassengersDeliveryActionFragmentDoc}`
